import { useEffect, useState } from 'react';
import Email from './Email';
import styles from './New.module.scss';
import SignInLink from '../SignInLink';
import TermsOfUseLinks from 'components/shared/TermsOfUseLinks';
import Phone from './Phone';
import Code from './Code';
import Password from './Password';
import BackHeader from 'modules/salon/pages/BackHeader';
import { useNavigate } from 'react-router-dom';
import useIsAuth from 'sdk/hooks/useIsAuth';
import { useTranslation } from 'react-i18next';

export enum SignUpSteps {
  Email = 'email',
  Phone = 'phone',
  Code = 'code',
  Password = 'password',
}

function SignUpNew() {
  const [step, setStep] = useState<SignUpSteps>(SignUpSteps.Email);
  const [name, setName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [phone, setPhone] = useState<string>('966');
  const [code, setCode] = useState(['', '', '', '']);
  const [password, setPassword] = useState<any>('');
  const { data: isAuthData } = useIsAuth();
  const { t } = useTranslation() as any;
  const [token, setToken] = useState<string>('');
  const navigate = useNavigate();

  const onBack = () => {
    if (step === SignUpSteps.Email) navigate(-1);
    if (step === SignUpSteps.Phone) setStep(SignUpSteps.Email);
    if (step === SignUpSteps.Code) setStep(SignUpSteps.Phone);
  };

  useEffect(() => {
    if (isAuthData?.isAuth) {
      navigate('/feed');
    }
  }, [isAuthData?.isAuth]);

  return (
    <div style={{ height: '100%' }}>
      <BackHeader title={t('sign_up')} onBack={onBack} />
      {/* STEPS START */}
      <div className={styles.container}>
        {step === SignUpSteps.Email && (
          <Email
            name={name}
            setName={setName}
            email={email}
            setEmail={setEmail}
            setStep={setStep}
          />
        )}
        {step === SignUpSteps.Phone && (
          <Phone phone={phone} setPhone={setPhone} setStep={setStep} />
        )}
        {step === SignUpSteps.Code && (
          <Code
            code={code}
            phone={phone}
            email={email}
            name={name}
            setCode={setCode}
            setStep={setStep}
            token={token}
            setToken={setToken}
          />
        )}
        {step === SignUpSteps.Password && (
          <Password
            phone={phone}
            email={email}
            name={name}
            password={password}
            setPassword={setPassword}
          />
        )}
      </div>
      {/* STEPS END */}

      {/* FOOTER START */}
      <div className={styles.footer}>
        <SignInLink onClick={() => navigate('/sign-in')} />

        <TermsOfUseLinks />
      </div>
      {/* FOOTER END */}
    </div>
  );
}

export default SignUpNew;
